<template>
  <div class="hot-category-wrapper">
    <p class="title-text" v-if="!hiddenTitle">
      <img class="yml-icon" :src="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/icon_like.png')" alt="">
      <span class="title">You May Also Like</span>
    </p>

    <div class="listings">
      <div class="listing-item" v-for="(item, idx) in recommendList" :key="idx">
        <PCProductItemCard :product-data="item" />
      </div>
    </div>

    <div class="load-more" @click="handleLoadMoreClick" v-if="!payload.isOver">
      <span class="loading" v-show="payload.loading">
        <van-loading size="20px" color="#DD3131" type="spinner" />
      </span>
      <span>SHOW MORE</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getRecommended } from '@/api/models/home'
import {
  buildAccountRecommendSource,
  buildCartRecommendSource,
  buildHomeRecommendSource,
  buildOrderDetailRecommendSource,
  buildPayResultRecommendSource,
  buildProductDetailRecommendSource
} from '@/plugins/utils'

const props = withDefaults(
  defineProps<{ 
    recommendId: number,
    skuIds?: number[],
    hiddenTitle?: boolean,
    pageSize?: number,
    clsId?: number,
    listingIds?: number[]
  }>(),
  {
    skuIds: () => ([])
  }
)

const route = useRoute()

const getSource = (modeName: string): string => {
  let so: string = ''
  // 购物车
  if(props.recommendId === 6){
    so = buildPayResultRecommendSource(modeName)
  } else if(props.recommendId === 1) {
    so = buildHomeRecommendSource(modeName)
  } else if(props.recommendId === 4) {
    so = buildProductDetailRecommendSource(modeName)
  } else if(props.recommendId === 8) {
    // 订单详情页虽共用 recommendId=8，来源需区分
    so = /^\/orders\/detail/.test(route.path)
      ? buildOrderDetailRecommendSource(modeName)
      : buildAccountRecommendSource(modeName)
  } else if(props.recommendId === 5) {
    so = buildCartRecommendSource(modeName)
  }
  return so
}

const recommendList = ref<any>([])
const payload = reactive<{
  skip: number, limit: number, isOver: boolean, loading: boolean
}>({ skip: 0, limit: props.pageSize || 24, isOver: false, loading: false })
const initRecommendList = async() => {
  if(payload.isOver || payload.loading) {
    return
  }

  payload.loading = true
  try {
    const excludeListings: number[] = props.listingIds?.length ? props.listingIds : []
    const { listings=[] } = await getRecommended(props.recommendId, payload, props.skuIds, props.clsId, excludeListings).then((r: any) => r.data)

    const _list = listings.map((c: any) => {
      const _so = getSource(c.modelName || c.algorithmModelName || '')
      _so && (c.source = _so)

      return c
    })
    
    recommendList.value.push(..._list)

    // payload.isOver = payload.limit > listings.length
    payload.isOver = listings.length.length <= 0
  } catch(e) {
    console.error(e)
  } finally {
    payload.loading = false
  }
}

onMounted(async() => {
  await initRecommendList()
})

const handleLoadMoreClick = async() => {
  payload.skip += payload.limit
  await initRecommendList()
}
</script>

<style lang="scss" scoped>
.load-more{
  margin: 80px auto;
  border: 2px solid #efefef;
  box-shadow: 0 0 4px #666;
  text-align: center;
  cursor: pointer;
  height: 80px;
  @include center();
  width: 600px;
  color: #666;
  font-weight: 800;
  // position: relative;
  .loading{
    margin-right: 16px;
  }
}
.title-text{
  font-size: 42px;
  height: 70px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #efefef;
  display: flex;
  align-items: center;
  .yml-icon{
    height: 50px;
    widows: 50px;
    margin-right: 16px;
  }
}
.listings{
  display: flex;
  flex-wrap: wrap;
  // width: 0;
  .listing-item{
    width: 16.66%;
    padding: 10px;
  }
}
</style>